import { defineAsyncComponent, defineComponent, h, type Component } from "vue";
import { type IconDefinition } from "@fortawesome/free-brands-svg-icons";

export type IconsDictionary = {
    facebook: AsyncComponentFactory;
    instagram: AsyncComponentFactory;
    linkedin: AsyncComponentFactory;
};

export type IconKey = keyof IconsDictionary;

async function FontawesomeIconDefinitionRender<
    T extends { definition: IconDefinition }
>(load: Promise<T>): Promise<Component> {
    const renderer = defineAsyncComponent(
        () =>
            import(
                /* webpackFetchPriority: "high" */
                "../../controls/shared/IconDefinitionRenderer.vue"
            )
    );
    const { definition } = await load;

    return /*#__PURE__*/ defineComponent({
        props: {
            color: String,
        },
        render: function () {
            return h(renderer, {
                value: definition,
                color: this.color,
            });
        },
    });
}

export type AsyncComponentFactory = () => Promise<Component>;

export const Dictionary: IconsDictionary = {
    facebook: () => {
        return FontawesomeIconDefinitionRender(
            import(
                /* webpackFetchPriority: "high" */
                "@fortawesome/free-brands-svg-icons/faFacebookF"
            )
        );
    },
    instagram: () => {
        return FontawesomeIconDefinitionRender(
            import(
                /* webpackFetchPriority: "high" */
                "@fortawesome/free-brands-svg-icons/faInstagram"
            )
        );
    },
    linkedin: () => {
        return FontawesomeIconDefinitionRender(
            import(
                /* webpackFetchPriority: "high" */
                "@fortawesome/free-brands-svg-icons/faLinkedinIn"
            )
        );
    },
};

export function getComponentForIcon(icon: IconKey) {
    if (!(icon in Dictionary)) {
        return null;
    }
    return Dictionary[icon];
}
